import { useState } from "react";
import DatePicker from "react-multi-date-picker";
import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian from "react-date-object/calendars/gregorian";
import english from "react-date-object/locales/gregorian_en";

import {
  Box,
  Select,
  MenuItem,
  Button,
  Typography,
  FormControl,
  InputLabel,
} from "@mui/material";

import { handleApplyFilterItemFunction } from "./FiltersContainer";
import { IOptionSchema, OperatorEnum } from "../../../../utils/types";
import ArrowForward from "@mui/icons-material/ArrowForward";
import TimePicker from "react-multi-date-picker/plugins/time_picker";

interface DateTimeFilterProps {
  handleApplyFilter: handleApplyFilterItemFunction;
  value: string;
  columnName: string;
  operator: string;
}

const operatorOptions: IOptionSchema[] = [
  { value: OperatorEnum.IS_EQUAL, label: "مساوی" },
  { value: OperatorEnum.IS_AFTER_THAN, label: "پس از" },
  { value: OperatorEnum.IS_BEFORE_THAN, label: "پیش از" },
];

function DateTimeFilter({
  handleApplyFilter,
  value,
  operator: operatorValue,
  columnName,
}: DateTimeFilterProps) {
  const initialDate =
    typeof value === "string" && value.length
      ? new DateObject({
          date: value,
          calendar: gregorian,
          locale: english,
        }).convert(persian)
      : null;

  const defaultOperator = operatorOptions.find(
    (opt) => opt.value === operatorValue
  );

  const [dateValue, setDateValue] = useState<DateObject | null>(initialDate);
  const [operator, setOperator] = useState<string>(
    defaultOperator?.value || OperatorEnum.IS_EQUAL
  );

  const applyHandler = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (dateValue instanceof DateObject) {
      const date = dateValue
        .convert(gregorian)
        .setLocale(english)
        .format("YYYY/MM/DD HH:mm:ss");
    
      handleApplyFilter(columnName, operator, date);
    }
  };

  return (
    <Box
      component="form"
      onSubmit={applyHandler}
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%",
        gap: 2,
      }}
    >
      <FormControl fullWidth size="small" dir="rtl">
        <InputLabel id="operator-label">عملگر</InputLabel>
        <Select
          labelId="operator-label"
          value={operator}
          label="عملگر"
          onChange={(e) => setOperator(e.target.value)}
          MenuProps={{
            PaperProps: {
              sx: {
                textAlign: "right",
                direction: "rtl",
              },
            },
          }}
        >
          {operatorOptions.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Box display="flex" alignItems="center" gap={2}>
        <ArrowForward sx={{ transform: "rotate(180deg)", color: "gray" }} />
        <Box sx={{ width: "100%" }}>
          <DatePicker
            calendar={persian}
            locale={persian_fa}
            value={dateValue}
            onChange={setDateValue}
            format="YYYY/MM/DD HH:mm:ss"
            plugins={[<TimePicker position="bottom" />]}
            inputClass="w-full h-9 px-3 py-2 border rounded-md border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
            containerClassName="w-full"
            style={{
              width: "100%",
              minHeight: "36px",
              fontSize: "0.875rem",
              padding: "0 0.75rem",
              borderRadius: "4px",
            }}
          />
        </Box>
      </Box>

      <Button
        type="submit"
        variant="contained"
        color="primary"
        fullWidth
        sx={{ alignSelf: "flex-start", height: 36 }}
      >
        تایید
      </Button>
    </Box>
  );
}

export default DateTimeFilter;
